import React, { useState } from 'react'
import { TableRow, TableCell, Collapse, IconButton } from '@mui/material'
import { J1ToparrowD, J1DownarrowD } from '@e3dc-react/icons'

import { CustomTableRowProps } from '../types'
import useStyles from '../styles'

const CustomTableRow: React.FC<CustomTableRowProps> = ({
  rowData,
  customFunctionalities,
  customFunctionalityClass,
  columnCount,
  collapsibleContent,
  onSelect,
  rowIndex,
  hasColoredTableColumns,
  bodyClassName,
}) => {
  const [collapsibleRowOpen, setCollapsibleRowOpen] = useState(false)

  const getIsColoredColumn = (rowIndex: number): boolean => {
    return rowIndex % 2 !== 0
  }

  const isColoredColumn = hasColoredTableColumns && getIsColoredColumn(rowIndex)
  const { classes, cx } = useStyles({ onSelect, coloredColumn: isColoredColumn })

  return (
    <>
      <TableRow
        hover={!!onSelect}
        onClick={onSelect}
        className={cx(classes.customTableRow, bodyClassName)}
        style={{ cursor: onSelect ? 'pointer' : 'default' }}
      >
        {collapsibleContent && (
          <TableCell key={`expand-row-${rowIndex}`}>
            <IconButton onClick={() => setCollapsibleRowOpen(!collapsibleRowOpen)} data-qa={`colapse-button-row-${rowIndex}`} size="large">
              {collapsibleRowOpen ? <J1ToparrowD /> : <J1DownarrowD />}
            </IconButton>
          </TableCell>
        )}
        {rowData.map((item, index) => {
          return (
            <TableCell
              key={`custom-row-cell-${index}`}
              sx={theme => ({
                '& > div': {
                  '& button': {
                    [theme.breakpoints.down('sm')]: {
                      width: 'min-content',
                    },
                  },
                },
              })}
            >
              {item}
            </TableCell>
          )
        })}
        {customFunctionalities?.map((value, idx) => {
          return (
            <TableCell
              key={`${rowIndex}-${idx}`}
              className={customFunctionalityClass}
              sx={{
                '& > div': {
                  justifyContent: 'flex-end',
                  gap: 1,

                  '& button': {
                    padding: 0,
                  },
                },
              }}
            >
              {value[rowIndex]}
            </TableCell>
          )
        })}
      </TableRow>
      {collapsibleContent && (
        <TableRow>
          <TableCell colSpan={columnCount + 1} style={{ padding: 0, borderColor: collapsibleRowOpen ? undefined : 'transparent' }}>
            <Collapse in={collapsibleRowOpen} timeout="auto" unmountOnExit>
              {collapsibleRowOpen && collapsibleContent()}
            </Collapse>
          </TableCell>
        </TableRow>
      )}
    </>
  )
}

export default CustomTableRow
